import {AurInfographicSeperatorProps} from './types';
import styles from './style.module.scss';
import {Box} from '@mui/material';
import {ReactComponent as ChevRightIcon} from '../../../assests/svg/infographic-right-chev.svg';
import {ReactComponent as ChevLeftIcon} from '../../../assests/svg/infographic-left-chev.svg';

const horizontalSeperator = (
  <Box className={`${styles.AurInfographicHorizontalSeperator}`}></Box>
);

const AurInfographicSeperator = ({
  seperatorIcon,
}: AurInfographicSeperatorProps) => {
  let seperator = null;

  switch (seperatorIcon) {
    case 'RightChevron':
      seperator = <ChevRightIcon aria-hidden="true" />;
      break;
    case 'LeftChevron':
      seperator = <ChevLeftIcon />;
      break;
    case 'VerticalLine':
      seperator = horizontalSeperator;
      break;

    default:
      seperator = seperatorIcon;
      break;
  }

  return <Box className={`${styles.AurInfographicSeperator}`}>{seperator}</Box>;
};

export default AurInfographicSeperator;
